export default __webpack_public_path__ + "static/media/more.5cd9fea8.svg";